export const TAG_GAME_IDS: Record<string, string> = {
  hot: "7000",
  baccarat: "9",
  bingo: "1015",
  blackjack: "7",
  bonusbuy: "13",
  card: "1011",
  casual: "1002",
  craps: "1004",
  crash: "1008",
  crashatigame: "1001",
  crashcasino: "1000",
  enhancedrtp: "14",
  exclusives: "11",
  "featurebuy-in": "5",
  fishing: "1010",
  gameshows: "12",
  highvolatility: "4",
  livecasino: "3",
  lottery: "1003",
  mahjong: "1014",
  minigame: "1013",
  newreleases: "10",
  "new-releases": "10",
  originals: "1",
  poker: "1006",
  provablyfairs: "1005",
  roulette: "8",
  slots: "2",
  softswiss: "9001",
  sports: "1012",
  "table-game": "6",
  videopoker: "1007",
  virtualsports: "1009",
  minigames: "1013",
};
